import { forgetPasswordSlice } from './forgetPassword/slice';
import { combineReducers } from '@reduxjs/toolkit';
import { workspaceSlice } from './workspace/slice';
import { generalSlice } from './general/slice';
import { signUpSlice } from './signUp/slice';
import { authSlice } from './auth/slice';
import { examSlice } from './exam/slice';

const appReducer = combineReducers({
  auth: authSlice.reducer,
  general: generalSlice.reducer,
  exam: examSlice.reducer,
  signUp: signUpSlice.reducer,
  workspace: workspaceSlice.reducer,
  forgetPassword: forgetPasswordSlice.reducer,
});

export const reducer = (state: any, action: any) => {
  if (action.type === 'auth/signOutThunk/fulfilled') {
    state = undefined;
  }
  return appReducer(state, action);
};